import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Dialog, DialogActions, DialogContent, Typography } from '@material-ui/core';

import Button from '../components/Button';
import FilterDialog from '../components/FilterDialog';
import PageGrid from '../components/PageGrid';
import PageHeader from '../components/PageHeader';
import { PersonContext } from '../contexts/PersonContext';
import history from '../history';

const ExpensesExport = () => {
  const location = useLocation();
  const { match } = useParams();
  const { organizationId } = useContext(PersonContext);

  const [filter, setFilter] = useState({
    startDate: null,
    endDate: null,
    startDateSelect: null,
    endDateSelect: null,
    entityId: null,
    propertyId: null,
    unitId: null,
    entityIdSelect: null,
    propertyIdSelect: null,
    unitIdSelect: null,
  });

  const [isFilterDialogOpen, setIsFilterDialogOpen] = useState(true);
  const [isExportDialogOpen, setIsExportDialogOpen] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const exportXlsx = async (newFilter) => {
    setIsExportDialogOpen(true);
    setIsLoading(true);
    setError(null);

    try {
      return await fetch(`${import.meta.env.VITE_FEATHERS_SOCKET}/export-xlsx`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('feathers-jwt')}`,
        },
        body: JSON.stringify({
          organizationId,
          page: `${location.pathname}`,
          filter: newFilter,
          reportName: 'Expenses',
        }),
      }).then(async (resp) => {
        if (!resp.ok) {
          const errorData = await resp.json();
          setError(errorData);
          return;
        }
        const blob = new Blob([await resp.blob()], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = 'expenses.xlsx';
        document.body.appendChild(a);
        a.click();
      });
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const updateFilter = (newFilter) => {
    setFilter(newFilter);
    setIsFilterDialogOpen(false);
    exportXlsx(newFilter);
  };

  useEffect(() => {
    if (!isFilterDialogOpen && !isExportDialogOpen) {
      history.replace('/reports');
    }
  }, [isFilterDialogOpen, isExportDialogOpen]);

  return (
    <PageGrid>
      <PageHeader match={match} title="Expenses Export" />
      {isFilterDialogOpen && (
        <FilterDialog
          filter={filter}
          isOpen
          closeDialog={() => {
            setIsFilterDialogOpen(false);
          }}
          updateFilter={(filter) => updateFilter(filter)}
          dateRange
          scope={['Full Portfolio', 'Sub-Portfolio', 'Property', 'Unit']}
          required={['dateRange', 'scope']}
        />
      )}
      <Dialog
        open={isExportDialogOpen}
        scroll="body"
        maxWidth="sm"
        fullWidth
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id="exportAttachmentDialog"
      >
        <DialogContent>
          {!error ? (
            <div>
              {isLoading ? (
                <Typography variant="h6" gutterBottom>
                  Exporting Expenses...
                </Typography>
              ) : (
                <Typography variant="h6" gutterBottom>
                  Export complete
                </Typography>
              )}
            </div>
          ) : (
            <Typography color="error">{error && `Error: ${error.message}`}</Typography>
          )}
          <DialogActions>
            {!error && (
              <Button
                variant="contained"
                color="primary"
                disableElevation
                onClick={() => {
                  setIsExportDialogOpen(false);
                }}
                disabled={isLoading}
              >
                Done
              </Button>
            )}
            {error && (
              <Button
                color="primary"
                onClick={() => {
                  setIsExportDialogOpen(false);
                  setIsFilterDialogOpen(true);
                }}
              >
                Back
              </Button>
            )}
          </DialogActions>
        </DialogContent>
      </Dialog>
    </PageGrid>
  );
};

export default ExpensesExport;
